import { css } from 'styled-components';

import Text from '../../../../shared/Text';
import { Badge } from '../../../../shared/Badge/Badge';
import RowAction from './RowAction.jsx';
import { parseDate } from '../../utils/helpers';
import { STATUS_CONFIG } from './CalendarView/helpers.js';

import { tableOverview } from '../../../../translations/en/campaigns.json';

const { onGoing } = tableOverview;

const STYLES = {
  first: css`
    padding: 0 0 0 24px;
  `,
  base: css`
    padding: 0 24px 0 0;
  `,
  dropdown: css`
    align-items: flex-end;
    justify-content: flex-end;
    padding-right: 24px;
  `,
};

const createStatusBadge = status => {
  const config = STATUS_CONFIG[status];
  if (!config) return null;

  return (
    <Badge
      variant="rounded"
      style={{
        backgroundColor: config.color,
        color: 'white',
        border: 'none',
      }}
    >
      {config.label}
    </Badge>
  );
};

const createCell = (
  content,
  style,
  clickable = true,
  shouldLinkTo = false,
) => ({
  content,
  style,
  clickable,
  shouldLinkTo,
});

const createTextCell = (
  text,
  color = 'black.100',
  style = STYLES.base,
  clickable = true,
  shouldLinkTo = true,
) => {
  return createCell(
    <Text variant="small2" color={color}>
      {text}
    </Text>,
    style,
    clickable,
    shouldLinkTo,
  );
};

const createCampaignRow = (
  row,
  userType,
  campaignStatus,
  highlightedCampaignUuid,
) => {
  // Show deletedAt date if campaign is deleted, otherwise show status badge
  const fourthColumnContent = row.deletedAt
    ? createTextCell(parseDate(row.deletedAt, '', 'LLL d, yyyy'))
    : createCell(createStatusBadge(row.status), STYLES.base, false);

  const isHighlighted = highlightedCampaignUuid === row.uuid;
  console.log('row', row.newHire);
  const cells = [
    createTextCell(row.name, 'primary.100', STYLES.first),
    createTextCell(parseDate(row.startDate, '', 'LLL d, yyyy')),
    createTextCell(parseDate(row.endDate, onGoing, 'LLL d, yyyy')),
    fourthColumnContent,
    createCell(
      <RowAction
        filter={campaignStatus}
        userType={userType}
        uuid={row.uuid}
        name={row.name}
        slug={row.slug}
        demoSlug={row.demoSlug}
        isArchived={row.isArchived}
        isNewHire={row.newHire}
        isMultiMonth={row.multiMonth}
      />,
      STYLES.dropdown,
      true,
    ),
  ];

  return {
    info: {
      dataTileId: row.uuid,
      uuid: row.uuid,
      clickable: true,
      hasDivider: true,
      className: isHighlighted ? 'highlighted' : '',
      dataHref: `/${row.uuid}/edit?from=highlights`,
    },
    cells,
  };
};

export const campaignTableRow = ({
  campaigns,
  userType,
  campaignStatus,
  highlightedCampaignUuid,
}) => {
  return campaigns.map(row =>
    createCampaignRow(row, userType, campaignStatus, highlightedCampaignUuid),
  );
};
